import {ChangeDetectionStrategy, Component, Input, OnInit, Output} from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { distinctUntilChanged, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** @title Basic datepicker */
@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerComponent implements OnInit {
    readonly dateCtrl = new FormControl(new Date());
    readonly minDate = new Date();

    @Input() date: Date;
    @Output() onDateChange = new EventEmitter()

    constructor(){
        this.dateCtrl.valueChanges.pipe(
            distinctUntilChanged(),
            tap(() => {
                const selectedDate = this.dateCtrl.getRawValue();
                this.onDateChange.emit(selectedDate);
            }),
            takeUntilDestroyed()
        ).subscribe();
    }

    ngOnInit() {
        this.dateCtrl.setValue(this.date);
    }
}